require.ensure(["./a"], function(require) {
	require("./a").should.be.eql("a");
})


/*****************
 ** WEBPACK FOOTER
 ** ./runtime/chunk-callback-order/duplicate.js
 ** module id = 1
 ** module chunks = 1
 **/